import { Children, ReactNode } from "react";
import { View } from "react-native";

export const ReadingsList = ({ children }: { children: ReactNode }) => {
    const rows = Children.toArray(children).filter(Boolean);
    if (rows.length === 0) return null;

    return (
        <View className="bg-white border border-gray-300 overflow-hidden rounded-2xl">
            {rows.map((row, index) => (
                <View key={index} className={index > 0 ? 'border-t border-gray-300' : ''}>
                    {row}
                </View>
            ))}
        </View>
    );
};

export default ReadingsList;
